import { graphql } from 'relay-runtime';

export const PROFILE_HEADER_QUERY = graphql`
  query ProfileHeaderQuery($username: String, $internalId: String) {
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
        ... on UnifiedProfile {
          role
          username
          location
          company
          aaid
          isProfileOwnerConsented
        }
      }
    }
  }
`;
